import { Box, styled } from '@mui/material';

export const LoadingWrapper = styled(Box)({
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'white',
    zIndex: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
});
